import {Card, Col, FloatingLabel, Form, Row} from 'react-bootstrap'
import {FormattedMessage, defineMessages, useIntl} from 'react-intl'
import {CommercialLead, PersonalLeadOneLead} from '../../leads/leadTypes'
import {useState} from 'react'

interface ICardInfoProps {
  leadId: string
  commercial: CommercialLead | null
  personal: PersonalLeadOneLead | null
}

const cM = defineMessages({
  leadTypeInfo: {id: 'leads.detail.leadTypeInformation', defaultMessage: 'Lead type information'},
  dba: {id: 'leads.form.commercial.dba', defaultMessage: 'DBA'},
  businessEntity: {id: 'leads.form.commercial.businessEntity', defaultMessage: 'Business entity'},
  businessClassification: {id: 'leads.form.commercial.businessClassification', defaultMessage: 'Business classification'},
  federalEin: {id: 'leads.form.commercial.federalEin', defaultMessage: 'Federal EIN'},
  businessStarted: {id: 'leads.form.commercial.businessStarted', defaultMessage: 'Business started'},
  numberEmployees: {id: 'leads.form.commercial.numberEmployees', defaultMessage: 'Number of employees'},
  totalPayroll: {id: 'leads.form.commercial.totalPayroll', defaultMessage: 'Total payroll'},
  secondPhoneComm: {id: 'leads.form.commercial.secondPhone', defaultMessage: 'Second commercial phone'},
  secondEmailComm: {id: 'leads.form.commercial.secondEmail', defaultMessage: 'Second commercial email'},
  contactFirstName: {id: 'leads.form.commercial.contactFirstName', defaultMessage: 'Contact first name'},
  contactMiddleName: {id: 'leads.form.commercial.contactMiddleName', defaultMessage: 'Contact middle name'},
  contactLastName: {id: 'leads.form.commercial.contactLastName', defaultMessage: 'Contact last name'},
  dateOfBirth: {id: 'common.field.dateOfBirth', defaultMessage: 'Date of Birth'},
  civilStatus: {id: 'leads.form.civilStatus', defaultMessage: 'Civil status'},
  secondPhone: {id: 'leads.form.secondPhone', defaultMessage: 'Second phone'},
  streetAddress: {id: 'leads.form.streetAddress', defaultMessage: 'Street address'},
  city: {id: 'common.field.city', defaultMessage: 'City'},
  country: {id: 'leads.form.country', defaultMessage: 'Country'},
  state: {id: 'common.field.state', defaultMessage: 'State'},
  postalCode: {id: 'common.field.zipCode', defaultMessage: 'Zip code'},
})

export const CardInfoPersonalCommercial: React.FC<ICardInfoProps> = ({commercial, personal}) => {
  const intl = useIntl()
  const na = intl.formatMessage({id: 'common.value.notAvailable', defaultMessage: 'N/A'})
  const [typeLead, setTypeLead] = useState<'commercial' | 'personal'>(() => {
    const t = commercial && personal ? 'commercial' : commercial ? 'commercial' : 'personal'
    return t
  })
  return (
    <Card>
      <Card.Header className='align-items-center'>
        <Card.Title>{intl.formatMessage(cM.leadTypeInfo)}</Card.Title>
        <div>
          <div
            style={{
              borderBottom: 0,
              display: 'flex',
              background: '#f6f7fb',
              padding: '6px',
              borderRadius: '60px',
            }}
            className='d-flex align-items-center'
          >
            <button
              style={{
                flex: 1,
                borderRadius: '20px',
                color: typeLead === 'personal' ? 'white' : undefined,
              }}
              className={`border-0 ${typeLead === 'personal' ? 'bg-primary' : 'bg-transparent'}`}
              onClick={() => {
                setTypeLead('personal')
              }}
            >
              <FormattedMessage id='leads.form.typePersonal' defaultMessage='Personal' />
            </button>
            <button
              style={{
                flex: 1,
                borderRadius: '20px',
                color: typeLead === 'commercial' ? 'white' : undefined,
              }}
              className={`border-0 ${typeLead === 'commercial' ? 'bg-primary' : 'bg-transparent'}`}
              onClick={() => {
                setTypeLead('commercial')
              }}
            >
              <FormattedMessage id='leads.form.typeCommercial' defaultMessage='Commercial' />
            </button>
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <Row>
          {typeLead === 'commercial' && (
            <>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='dba' label={intl.formatMessage(cM.dba)}>
                  <Form.Control
                    name='dba'
                    type='text'
                    placeholder={intl.formatMessage(cM.dba)}
                    defaultValue={commercial?.dba || na}
                    style={{color: commercial?.dba ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='businessEntity' label={intl.formatMessage(cM.businessEntity)}>
                  <Form.Control
                    name='businessEntity'
                    type='text'
                    placeholder={intl.formatMessage(cM.businessEntity)}
                    defaultValue={commercial?.businessEntity || na}
                    style={{color: commercial?.businessEntity ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 2 */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='businessClassification' label={intl.formatMessage(cM.businessClassification)}>
                  <Form.Control
                    name='businessClassification'
                    type='text'
                    placeholder={intl.formatMessage(cM.businessClassification)}
                    defaultValue={commercial?.businessClassification || na}
                    style={{color: commercial?.businessClassification ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='federalEin' label={intl.formatMessage(cM.federalEin)}>
                  <Form.Control
                    name='federalEin'
                    type='text'
                    placeholder={intl.formatMessage(cM.federalEin)}
                    defaultValue={commercial?.federalEin || na}
                    style={{color: commercial?.federalEin ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 3 */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='businessStarted' label={intl.formatMessage(cM.businessStarted)}>
                  <Form.Control
                    name='businessStarted'
                    type='text'
                    placeholder={intl.formatMessage(cM.businessStarted)}
                    defaultValue={commercial?.businessStarted || na}
                    style={{color: commercial?.businessStarted ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='numberEmployees' label={intl.formatMessage(cM.numberEmployees)}>
                  <Form.Control
                    name='numberEmployees'
                    type={commercial?.numberEmployees ? 'number' : 'text'}
                    placeholder={intl.formatMessage(cM.numberEmployees)}
                    defaultValue={commercial?.numberEmployees || na}
                    style={{color: commercial?.numberEmployees ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 4 */}
              {/* <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='annualRevenue' label='Annual Revenue'>
                  <Form.Control
                    name='annualRevenue'
                    type='text'
                    placeholder='Annual Revenue'
                    defaultValue={'N/R'}
                    readOnly
                  />
                </FloatingLabel>
              </Col> */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='totalPayroll' label={intl.formatMessage(cM.totalPayroll)}>
                  <Form.Control
                    name='totalPayroll'
                    type='text'
                    placeholder={intl.formatMessage(cM.totalPayroll)}
                    defaultValue={commercial?.totalPayroll || na}
                    style={{color: commercial?.totalPayroll ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 5 */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='secondPhone' label={intl.formatMessage(cM.secondPhoneComm)}>
                  <Form.Control
                    name='secondPhone'
                    type='text'
                    placeholder={intl.formatMessage(cM.secondPhoneComm)}
                    defaultValue={commercial?.secondPhone || na}
                    style={{color: commercial?.secondPhone ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='secondEmail' label={intl.formatMessage(cM.secondEmailComm)}>
                  <Form.Control
                    name='secondEmail'
                    type='email'
                    placeholder={intl.formatMessage(cM.secondEmailComm)}
                    defaultValue={commercial?.secondEmail || na}
                    style={{color: commercial?.secondEmail ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 6 */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='contactFirstname' label={intl.formatMessage(cM.contactFirstName)}>
                  <Form.Control
                    name='contactFirstname'
                    type='text'
                    placeholder={intl.formatMessage(cM.contactFirstName)}
                    defaultValue={commercial?.contactFirstname || na}
                    style={{color: commercial?.contactFirstname ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='contactMiddlename' label={intl.formatMessage(cM.contactMiddleName)}>
                  <Form.Control
                    name='contactMiddlename'
                    type='text'
                    placeholder={intl.formatMessage(cM.contactMiddleName)}
                    defaultValue={commercial?.contactMiddlename || na}
                    style={{color: commercial?.contactMiddlename ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 7 */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='contactLastname' label={intl.formatMessage(cM.contactLastName)}>
                  <Form.Control
                    name='contactLastname'
                    type='text'
                    placeholder={intl.formatMessage(cM.contactLastName)}
                    defaultValue={commercial?.contactLastname || na}
                    style={{color: commercial?.contactLastname ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
            </>
          )}
          {typeLead === 'personal' && (
            <>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='birthDay' label={intl.formatMessage(cM.dateOfBirth)}>
                  <Form.Control
                    name='birthDay'
                    type='date'
                    placeholder={intl.formatMessage(cM.dateOfBirth)}
                    defaultValue={personal?.birthDay || undefined}
                    style={{color: personal?.birthDay ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='civilStatus' label={intl.formatMessage(cM.civilStatus)}>
                  <Form.Control
                    name='civilStatus'
                    type='text'
                    placeholder={intl.formatMessage(cM.civilStatus)}
                    defaultValue={personal?.civilStatus || na}
                    readOnly
                    style={{color: personal?.civilStatus ? undefined : '#d6d6d6'}}
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 9 */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='secondPhone' label={intl.formatMessage(cM.secondPhone)}>
                  <Form.Control
                    type='text'
                    name='secondPhone'
                    placeholder={intl.formatMessage(cM.secondPhone)}
                    defaultValue={personal?.secondPhone || na}
                    readOnly
                    style={{color: personal?.secondPhone ? undefined : '#d6d6d6'}}
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='streetAddress' label={intl.formatMessage(cM.streetAddress)}>
                  <Form.Control
                    name='streetAddress'
                    type='text'
                    placeholder={intl.formatMessage(cM.streetAddress)}
                    defaultValue={personal?.streetAddress || na}
                    style={{color: personal?.streetAddress ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 10 */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='city' label={intl.formatMessage(cM.city)}>
                  <Form.Control
                    name='city'
                    type='text'
                    placeholder={intl.formatMessage(cM.city)}
                    defaultValue={personal?.city || na}
                    readOnly
                    style={{color: personal?.city ? undefined : '#d6d6d6'}}
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='country' label={intl.formatMessage(cM.country)}>
                  <Form.Control
                    name='country'
                    type='text'
                    placeholder={intl.formatMessage(cM.country)}
                    defaultValue={personal?.country || na}
                    style={{color: personal?.country ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>

              {/* Grupo 11 */}
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='state' label={intl.formatMessage(cM.state)}>
                  <Form.Control
                    type='text'
                    name='state'
                    placeholder={intl.formatMessage(cM.state)}
                    defaultValue={personal?.state || na}
                    style={{color: personal?.state ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                <FloatingLabel controlId='postalCode' label={intl.formatMessage(cM.postalCode)}>
                  <Form.Control
                    name='postalCode'
                    type='text'
                    placeholder={intl.formatMessage(cM.postalCode)}
                    defaultValue={personal?.postalCode || na}
                    style={{color: personal?.postalCode ? undefined : '#d6d6d6'}}
                    readOnly
                  />
                </FloatingLabel>
              </Col>
            </>
          )}
        </Row>
      </Card.Body>
    </Card>
  )
}
